import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Flex } from "@chakra-ui/react";
import { useNav } from "~/OnboardingApp/features/Nav";
import { BottomRightArrow } from "./BottomRightArrow";

export const GetStartedCta: FC = () => {
  const { t } = useTranslation();
  const { goToNext } = useNav();

  const handleContinue = () => {
    goToNext();
  };

  return (
    <Flex justify="center" mb="15rem" w="full">
      <Box maxW="12rem" position="relative" w="full">
        <Button
          onClick={handleContinue}
          size="th-md"
          variant="th-primary"
          w="full"
        >
          {t("onboarding.welcomePage.nextCta")}
        </Button>
        <BottomRightArrow />
      </Box>
    </Flex>
  );
};
